export enum stripeInvoiceStatus {
	draft = 'Pending',
	open = 'Open',
	paid = 'Paid',
	uncollectible = 'Uncollectible',
	void = 'Void',
}
